import { z } from "zod";
/** AR-008 — explicit approval invalidation plan when artifact truth changes. */
export const ApprovalInvalidationPlanV1Schema = z
    .object({
    schemaId: z.literal("approval.invalidationPlan.v1"),
    shouldInvalidate: z.boolean(),
    reasons: z.array(z.string().min(1)),
    revokeClientApprovalRecord: z.boolean(),
    invalidateAffectedQa: z.boolean(),
})
    .strict();
export function planApprovalInvalidationOnArtifactChange(input) {
    const reasons = [];
    let shouldInvalidate = false;
    if (input.approvalRunId !== input.latestRunId) {
        shouldInvalidate = true;
        reasons.push("latest passing run changed since approval");
    }
    if (input.approvalArtifactSetHash !== input.latestArtifactSetHash) {
        shouldInvalidate = true;
        reasons.push("artifact set hash changed since approval");
    }
    if (input.approvedIntegrityRef !== input.latestIntegrityRef) {
        shouldInvalidate = true;
        reasons.push("artifact integrity changed since approval");
    }
    return ApprovalInvalidationPlanV1Schema.parse({
        schemaId: "approval.invalidationPlan.v1",
        shouldInvalidate,
        reasons,
        revokeClientApprovalRecord: shouldInvalidate,
        invalidateAffectedQa: shouldInvalidate,
    });
}
//# sourceMappingURL=artifact-registry-invalidation.js.map